<template>
    <div class="levelSelect">
        <div class="levelItem" v-for="(level, index) in levelStatuses" :key="index" @click="selectLevel(index+1)">
           <h1 :class="selectedLevel(index)">{{index+1}}</h1>
           <div class="lock" :class="getLevelStatus(index)"></div>
           <div class="star" :class="getStarStatus(index)"></div>
        </div>
    </div>
</template>

<script>
import { eventBus } from "../main";
export default {
    name: "levelSelect",
    props: {
        levelStatuses: {
            type:Array,
            default:0
        },
        currentLevel: {
            type:Number,
            default:1
        }
    },
    computed: {
    },
    methods: {
        getLevelStatus(index) {
            if(this.levelStatuses[index]==0) {
                return "locked"
            } else {
                return "open"
            }
        },
        getStarStatus(index) {
            if(this.levelStatuses[index]==0) {
                return ""
            }
            if(this.levelStatuses[index]==1) {
                return "starGrey"
            }
            if(this.levelStatuses[index]==2) {
                return "starGold"
            }
        },
        selectedLevel(index) {
            var curLevel = Number(index+1)
            if(curLevel == this.currentLevel) {
                return "txt-yellow"
            } else {
                // if level is locked
                if(this.levelStatuses[index]==0) {
                    return "h1Locked"
                } else {
                    return ""
                }
            }
        },
        selectLevel(level) {
            if(this.levelStatuses[level-1] > 0 ) {
                eventBus.$emit("levelWasSelected", level);
            }
        }
    }
};
</script>
<style scoped>
.levelSelect {
    display: inline-block;
    float:left;
    margin-left:2.5%;
    width:75%;
    height:100%;
}
h1 {
    position:absolute;
    top:0;
    left:0;
    font-size: 2.75vh;
    color:#CCCCCC;
    margin: 0 0 0 5vh;
    padding: 0;
}
.txt-yellow {
    color: #ffc500;
    border-bottom:4px solid #ffc500;
}
.levelItem {
    display: inline-block;
    position:relative;
    float:left;
    height:100%;
    width:30%;
}
.levelItem:hover {
    cursor: pointer;
}

.locked {
    position:absolute;
    top:5%;
    left:50%;
    width:50%;
    height:100%;
    background-image: url(../assets/images/locked.svg);
    background-repeat: no-repeat;
    background-position: center;
    transform: rotate(25deg)
}
.h1Locked {
    color:#E5E5E5;
}
.star {
    position:absolute;
    height:100%;
    width:50%;
    top:0;
    left:60%;
    background-repeat: no-repeat;
}
.starGrey {
    background-image: url(../assets/images/star-grey.svg);
}
.starGold {
    background-image: url(../assets/images/star-gold.svg);
}
</style>
